export default "__VITE_PUBLIC_ASSET__f463b15f__"